import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  private user: any;
  private userUpdatedFlag: Subject<boolean> = new Subject<boolean>();
  isUserUpdated$ = this.userUpdatedFlag.asObservable();

  constructor() { }

  get userObj(): any {
    const vm = this;
    vm.user = JSON.parse(sessionStorage.getItem('user'));
    return vm.user;
  }

  login(user: any) {
    const vm = this;
    vm.user = user;
    sessionStorage.setItem('user', JSON.stringify(vm.user));
    vm.userUpdatedFlag.next(true);
  }

  logout() {
    const vm = this;
    vm.user = null;
    sessionStorage.removeItem('user');
    vm.userUpdatedFlag.next(true);
  }
}
